import Splide from '@splidejs/splide';

(function() {
	'use strict';

	var BREAKPOINT_TABLET = 1024;

	function ready(callback) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', callback);
			return;
		}

		callback();
	}

	function each(selector, callback, root) {
		Array.prototype.forEach.call((root || document).querySelectorAll(selector), callback);
	}

	function prepareSplideMarkup(element) {
		if (element.classList.contains('splide') && element.querySelector(':scope > .splide__track')) {
			return;
		}

		var slides = Array.prototype.slice.call(element.children);
		var track = document.createElement('div');
		var list = document.createElement('div');

		element.classList.add('splide');
		element.classList.remove('row');
		track.className = 'splide__track';
		list.className = 'splide__list';

		slides.forEach(function(slide) {
			slide.classList.add('splide__slide');
			list.appendChild(slide);
		});

		track.appendChild(list);
		element.appendChild(track);
	}

	function initSplideCarousel(selectorOrElement, options) {
		var elements = typeof selectorOrElement === 'string'
			? document.querySelectorAll(selectorOrElement)
			: [selectorOrElement];

		Array.prototype.forEach.call(elements, function(element) {
			if (!element || element.dataset.splideReady === 'true') {
				return;
			}

			prepareSplideMarkup(element);
			new Splide(element, options || {}).mount();
			element.dataset.splideReady = 'true';
		});
	}

	function initSliders() {
		each('.partners-block__slider', function(slider) {
			if (slider.querySelectorAll('.partners-block__item').length <= 5) {
				return;
			}

			initSplideCarousel(slider, {
				type: 'loop',
				perPage: 5,
				perMove: 1,
				autoplay: true,
				interval: 3500,
				pauseOnHover: true,
				arrows: false,
				pagination: false,
				gap: '1.25rem',
				breakpoints: {
					1200: { perPage: 4 },
					960: { perPage: 3 },
					600: { perPage: 2 }
				}
			});
		});

		initSplideCarousel('.events-block__slider', {
			destroy: true,
			breakpoints: {
				767: {
					destroy: false,
					type: 'slide',
					rewind: false,
					perPage: 1,
					perMove: 1,
					gap: '1rem',
					pagination: true,
					arrows: false
				}
			}
		});
	}

	function initZajeciaStale() {
		each('.zajecia-stale-block', function(block) {
			var openButton = block.querySelector('.js-zajecia-stale-open');
			var modal = block.querySelector('.js-zajecia-stale-modal');
			var form = block.querySelector('.js-zajecia-stale-form');

			if (!openButton || !modal || !form || modal.dataset.hidigitalReady === 'true') {
				return;
			}

			modal.dataset.hidigitalReady = 'true';

			var closeButton = modal.querySelector('.js-zajecia-stale-close');
			var status = form.querySelector('.zajecia-stale-form__status');
			var submitButton = form.querySelector('.zajecia-stale-form__submit');
			var submitLabel = submitButton ? submitButton.textContent : '';
			var ajaxUrl = (window.hidigitalAjax && window.hidigitalAjax.url) ? window.hidigitalAjax.url : '/wp-admin/admin-ajax.php';

			function setStatus(message, type) {
				if (!status) {
					return;
				}

				status.hidden = !message;
				status.textContent = message || '';
				status.classList.remove('zajecia-stale-form__status--error', 'zajecia-stale-form__status--success');

				if (type) {
					status.classList.add('zajecia-stale-form__status--' + type);
				}
			}

			function openModal() {
				setStatus('', '');
				if (typeof modal.showModal === 'function') {
					modal.showModal();
				} else {
					modal.setAttribute('open', '');
				}

				var firstField = form.querySelector('select, input:not([type="hidden"]):not([tabindex="-1"])');
				if (firstField) {
					firstField.focus();
				}
			}

			function closeModal() {
				if (typeof modal.close === 'function') {
					if (modal.open) {
						modal.close();
					}
				} else {
					modal.removeAttribute('open');
					openButton.focus();
				}
			}

			modal.addEventListener('close', function() {
				openButton.focus();
			});

			openButton.addEventListener('click', openModal);

			if (closeButton) {
				closeButton.addEventListener('click', closeModal);
			}

			modal.addEventListener('click', function(event) {
				if (event.target === modal) {
					closeModal();
				}
			});

			form.addEventListener('submit', function(event) {
				event.preventDefault();
				setStatus('', '');

				var classField = form.querySelector('[name="class_index"]');
				var nameField = form.querySelector('[name="full_name"]');
				var emailField = form.querySelector('[name="email"]');
				var phoneField = form.querySelector('[name="phone"]');
				var nameValue = nameField ? nameField.value.trim() : '';
				var emailValue = emailField ? emailField.value.trim() : '';
				var phoneDigits = phoneField ? phoneField.value.replace(/\D+/g, '') : '';

				if (!classField || classField.value === '') {
					setStatus('Wybierz zajęcia z listy.', 'error');
					if (classField) {
						classField.focus();
					}
					return;
				}

				if (nameValue.length < 2) {
					setStatus('Podaj imię i nazwisko.', 'error');
					if (nameField) {
						nameField.focus();
					}
					return;
				}

				if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
					setStatus('Podaj poprawny adres e-mail.', 'error');
					if (emailField) {
						emailField.focus();
					}
					return;
				}

				if (phoneDigits.length < 9) {
					setStatus('Podaj poprawny numer telefonu.', 'error');
					if (phoneField) {
						phoneField.focus();
					}
					return;
				}

				if (submitButton) {
					submitButton.disabled = true;
					submitButton.textContent = 'Wysyłanie…';
				}

				fetch(ajaxUrl, {
					method: 'POST',
					credentials: 'same-origin',
					body: new FormData(form)
				}).then(function(response) {
					return response.json().then(function(payload) {
						return {
							ok: payload && payload.success,
							payload: payload
						};
					});
				}).then(function(result) {
					var message = result.payload && result.payload.data && result.payload.data.message
						? result.payload.data.message
						: (result.ok ? 'Dziękujemy! Zgłoszenie zostało wysłane.' : 'Nie udało się wysłać zgłoszenia. Spróbuj ponownie.');

					if (result.ok) {
						form.reset();
						setStatus(message, 'success');
						return;
					}

					setStatus(message, 'error');
				}).catch(function() {
					setStatus('Nie udało się wysłać zgłoszenia. Spróbuj ponownie.', 'error');
				}).then(function() {
					if (submitButton) {
						submitButton.disabled = false;
						submitButton.textContent = submitLabel;
					}
				});
			});
		});
	}

	function initGalleryLightbox() {
		if (!document.querySelector('section.gallery a.img[data-lightbox]')) {
			return;
		}

		var lightbox = document.getElementById('gallery-lightbox');
		if (!lightbox) {
			lightbox = document.createElement('div');
			lightbox.id = 'gallery-lightbox';
			lightbox.setAttribute('aria-hidden', 'true');
			lightbox.style.cssText = 'display:none;position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.92);align-items:center;justify-content:center;padding:24px;';
			lightbox.innerHTML =
				'<button type="button" class="gallery-lightbox-close" aria-label="Zamknij" style="position:absolute;top:16px;right:16px;border:0;background:transparent;color:#fff;font-size:44px;line-height:1;cursor:pointer;">&times;</button>' +
				'<button type="button" class="gallery-lightbox-prev" aria-label="Poprzednie" style="position:absolute;left:16px;top:50%;transform:translateY(-50%);border:0;background:transparent;color:#fff;font-size:44px;line-height:1;cursor:pointer;display:none;">&#8249;</button>' +
				'<img class="gallery-lightbox-image" alt="" style="display:block;max-width:min(1200px,100%);max-height:90vh;width:auto;height:auto;box-shadow:0 20px 60px rgba(0,0,0,0.45);">' +
				'<button type="button" class="gallery-lightbox-next" aria-label="Następne" style="position:absolute;right:16px;top:50%;transform:translateY(-50%);border:0;background:transparent;color:#fff;font-size:44px;line-height:1;cursor:pointer;display:none;">&#8250;</button>';
			document.body.appendChild(lightbox);
		}

		var image = lightbox.querySelector('.gallery-lightbox-image');
		var prevButton = lightbox.querySelector('.gallery-lightbox-prev');
		var nextButton = lightbox.querySelector('.gallery-lightbox-next');
		var items = [];
		var currentIndex = 0;

		function renderLightbox() {
			var item = items[currentIndex];
			if (!item) {
				return;
			}

			image.setAttribute('src', item.href);
			prevButton.style.display = items.length > 1 ? 'block' : 'none';
			nextButton.style.display = items.length > 1 ? 'block' : 'none';
		}

		function closeLightbox() {
			lightbox.style.display = 'none';
			lightbox.setAttribute('aria-hidden', 'true');
			document.body.style.overflow = '';
		}

		function openLightbox(trigger) {
			var groupId = trigger.getAttribute('data-lightbox');
			var group = Array.prototype.slice.call(document.querySelectorAll('section.gallery a.img[data-lightbox="' + groupId + '"]'));
			items = group.map(function(item) {
				return {
					href: item.getAttribute('href')
				};
			});
			currentIndex = group.indexOf(trigger);
			renderLightbox();
			lightbox.style.display = 'flex';
			lightbox.setAttribute('aria-hidden', 'false');
			document.body.style.overflow = 'hidden';
		}

		document.body.addEventListener('click', function(event) {
			var trigger = event.target.closest('section.gallery a.img[data-lightbox]');
			if (!trigger) {
				return;
			}

			event.preventDefault();
			openLightbox(trigger);
		});

		lightbox.addEventListener('click', function(event) {
			if (event.target === lightbox) {
				closeLightbox();
			}
		});

		lightbox.querySelector('.gallery-lightbox-close').addEventListener('click', closeLightbox);
		prevButton.addEventListener('click', function() {
			currentIndex = (currentIndex - 1 + items.length) % items.length;
			renderLightbox();
		});
		nextButton.addEventListener('click', function() {
			currentIndex = (currentIndex + 1) % items.length;
			renderLightbox();
		});

		document.addEventListener('keydown', function(event) {
			if (lightbox.getAttribute('aria-hidden') !== 'false') {
				return;
			}

			if (event.key === 'Escape') {
				closeLightbox();
			}

			if (event.key === 'ArrowLeft' && items.length > 1) {
				currentIndex = (currentIndex - 1 + items.length) % items.length;
				renderLightbox();
			}

			if (event.key === 'ArrowRight' && items.length > 1) {
				currentIndex = (currentIndex + 1) % items.length;
				renderLightbox();
			}
		});
	}

	function setMobileNavOpen(isOpen) {
		var header = document.querySelector('.site-header');
		if (!header) {
			return;
		}

		header.classList.toggle('is-mobile-open', isOpen);
		each('.js-site-header-toggle', function(toggle) {
			toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		}, header);
		each('.site-header__mobile-panel', function(panel) {
			panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
		}, header);
		document.body.classList.toggle('has-mobile-nav', isOpen);
	}

	function alignDesktopSubmenus() {
		var items = document.querySelectorAll('.site-header__menu > li.menu-item-has-children');
		var pad = 12;

		Array.prototype.forEach.call(items, function(item) {
			item.classList.remove('is-submenu-start', 'is-submenu-end');
		});

		if (window.innerWidth < 992) {
			return;
		}

		Array.prototype.forEach.call(items, function(item) {
			var submenu = item.querySelector(':scope > .sub-menu');

			if (!submenu) {
				return;
			}

			var rect = submenu.getBoundingClientRect();

			if (rect.left < pad) {
				item.classList.add('is-submenu-start');
			} else if (rect.right > window.innerWidth - pad) {
				item.classList.add('is-submenu-end');
			}
		});
	}

	function initDesktopSubmenus() {
		alignDesktopSubmenus();
		window.addEventListener('resize', alignDesktopSubmenus);
	}

	function initMobileNav() {
		each('.js-site-header-toggle', function(button) {
			button.addEventListener('click', function() {
				var header = document.querySelector('.site-header');
				if (!header) {
					return;
				}

				setMobileNavOpen(!header.classList.contains('is-mobile-open'));
			});
		});

		each('.site-header__mobile-panel', function(panel) {
			panel.addEventListener('click', function(event) {
				if (event.target !== panel) {
					return;
				}

				setMobileNavOpen(false);
			});
		});

		each('.site-header__mobile-menu .menu-item-has-children > a', function(link) {
			link.addEventListener('click', function(event) {
				if (window.innerWidth <= BREAKPOINT_TABLET) {
					event.preventDefault();
					link.parentElement.classList.toggle('is-open');
				}
			});
		});
	}

	ready(function() {
		console.log('Ta strona jest wykonana przez Hi Digital. Poznaj nas lepiej na stronie https://hidigital.pl');
		initMobileNav();
		initDesktopSubmenus();
		initGalleryLightbox();
		initZajeciaStale();
		initSliders();
	});
}());
